// extracted by mini-css-extract-plugin
module.exports = {"close":"closeButton-module__close___A52hc"};